import PagedTable from '../../components/sorted-table/PagedTable';
import { getBillingHistoryOData } from '../../api/accountBillingExclusionHistory';
import { AccountBillingExclusionHistory } from '../../types/interfaces/accountBillingExclusionHistory';
import { StandardParamsToODataParams } from '../../types/interfaces';
import { TABLE_HEADER_CONSTANTS, LABEL_CONSTANTS } from '../../constants/common';

type BillingHistoryProps = {
  refresh: number;
  buildFilter: () => string;
  data: AccountBillingExclusionHistory[];
};

const BillingHistoryTable = ({ refresh, buildFilter, data }: BillingHistoryProps) => {
  return (
    <>
      <div className="billing-history-section">
        <PagedTable
          headers={[
            { displayName: TABLE_HEADER_CONSTANTS.MONTH },
            { displayName: TABLE_HEADER_CONSTANTS.ACCOUNT_OWNER },
            { displayName: TABLE_HEADER_CONSTANTS.PERMANENTLY_DISABLED },
          ]}
          getData={params =>
            getBillingHistoryOData(StandardParamsToODataParams({ ...params, filter: buildFilter(), include: 'Account' }))
          }
          pageSize={8}
          minHeight={140}
          height={325}
          refresh={refresh}
          noResultsMessage={LABEL_CONSTANTS.NO_DISABLED_ACCOUNTS_FOUND}
          buildRow={account => [
            account.billingDisabledMonth
              ? new Date(account.billingDisabledMonth).toLocaleString('en-US', { month: 'long', year: 'numeric' })
              : '--',
            account.account?.name,
            account.isBillingPermanentlyDisabled ? 'Yes' : 'No',
          ]}
        />
      </div>

      {/* ===== MOBILE ===== */}
      <div className="xs-billing-management history-mobile">
        {data.length === 0 ? (
          <div className="result-item">{LABEL_CONSTANTS.NO_DISABLED_ACCOUNTS_FOUND}.</div>
        ) : (
          data.map(history => (
            <div className="card max-width" key={history.accountBillingExclusionHistoryId}>
              <div className="billing-management-card">
                <div className="billing-management-content history-no-action">
                  <div className="billing-info">
                    <div className="billing-content">
                      <label>{TABLE_HEADER_CONSTANTS.ACCOUNT_OWNER} :</label>
                      <label>{history.account?.name}</label>
                    </div>

                    <div className="billing-content">
                      <label>{TABLE_HEADER_CONSTANTS.START_MONTH} :</label>
                      <label>
                        {history.billingDisabledMonth ? new Date(history.billingDisabledMonth).toLocaleDateString() : '--'}
                      </label>
                    </div>
                  </div>

                  <div className="billing-info">
                    <div className="billing-content">
                      <label>{TABLE_HEADER_CONSTANTS.PERMANENTLY_DISABLED} :</label>
                      <label>{history.isBillingPermanentlyDisabled ? 'Yes' : 'No'}</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))
        )}
      </div>
    </>
  );
};

export default BillingHistoryTable;
